import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { APIService } from '../api/api.service'
import { LocalStorageService } from '../local-storage/local-storage.service';
import { AppearanceService } from '../appearance/appearance.service';
import { Constants } from '../../constants/constants';
import { ClientModel } from 'src/app/models/client.model';
import { FilterModel } from 'src/app/models/filter.model';
import { TabService } from '../tab/tab.service';
import { HistoryModel } from 'src/app/models/history.model';
import { RemedialModel } from 'src/app/models/remedial.model';
import { AssetModel } from 'src/app/models/asset.model';
import { StockItemModel } from 'src/app/models/stock-item.model';
import { BadgeModel } from 'src/app/models/badge.model';
import { AssetTypeModel } from 'src/app/models/asset-type.model';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientService 
{
  client: ClientModel;
  allClients: Array<FilterModel> = [];
  badges: BadgeModel;

  selectedOrganisation: FilterModel;


  constructor(private apiService: APIService, private localStorageService: LocalStorageService,
    private appearanceService: AppearanceService, 
    private tabService: TabService) 
  {
    this.initService();
  }


  initService()
  {
    this.apiService.baseUrl = Constants.PROD_URL;

    this.appearanceService.listenForEvent('storage:loaded', (data: any) => {

       //this.loadFromLocalData();

    });
  }


  loadFromLocalData() 
  {
    this.client = this.localStorageService.getClient();
    this.allClients = this.localStorageService.getAllClients();
    this.selectedOrganisation = this.localStorageService.getSelectedOrganisation();

    if (this.client)
    {
      this.appearanceService.triggerEvent('user:loggedin', {
        time: new Date()
      });
    }
  }


  public getClientProfile()
  {
    var payload = {
      clientUid: this.client.clientUid
    }

    return this.apiService.getClientProfile(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client.addressOne = response.Client.addressOne;
        this.client.addressTwo = response.Client.addressTwo;
        this.client.addressCity = response.Client.addressCity;
        this.client.addressPostCode = response.Client.addressPostCode;

        this.client.history = Array<HistoryModel>();

          for (var i = 0; i < response.Client.history.length; i++)
          {
            var log = response.Client.history[i];

            var newLog      = new HistoryModel();
            newLog.uid      = log.historyUid;
            newLog.dateTime = log.historyDateTime;
            newLog.log      = log.HistoryLog;
            newLog.userName = log.historyUser;

            this.client.history.push(newLog);
          }

        this.localStorageService.saveClient(this.client);
      }

      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public updateClient()
  {
    return this.apiService.updateClient(this.client).pipe(map((response: any) => {

      if (response.Success)
      {
        this.localStorageService.saveClient(this.client);
      }

      return response;

    }),
      catchError((err) => {return throwError(() => err);  })
    );
  }


  public getClientDetailsOnLogin(clientUid, organisationUid, allClients): any 
  { 
    var payload = {
      ClientUid: clientUid,
      OrganisationUid: organisationUid
    }

    this.client = new ClientModel();

    return this.apiService.getClientDetailsOnLogin(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.allClients = Array<FilterModel>();

        this.client.clientUid                       = Number(response.Client.clientUid);
        this.client.clientName                      = response.Client.clientName;
        this.client.addressOne                      = response.Client.addressOne;
        this.client.addressTwo                      = response.Client.addressTwo;
        this.client.addressCity                     = response.Client.addressCity;
        this.client.addressPostCode                 = response.Client.addressPostCode;
        
        this.tabService.firstLoginSaveTabs(this.client.clientUid);
              
        this.clientOrOrganisationChanged(response, false);

        for (var i = 0; i < allClients.length; i++)
        {
          var choice = allClients[i];
          var newChoice   = new FilterModel();
          newChoice.uid   = Number(choice.uid);
          newChoice.name  = choice.name;
          this.allClients.push(newChoice);
        }

        this.localStorageService.saveClient(this.client);
        this.localStorageService.saveAllClients(this.allClients);
      }
      else
      {
        this.localStorageService.saveClient(null);
        this.localStorageService.saveAllClients(null);
      }
      
      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public changeClient(clientUid): any 
  { 
    var payload = {
      clientUid: clientUid
    }

    return this.apiService.changeClient(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client = new ClientModel();

        this.client.clientUid       = Number(response.Client.clientUid);
        this.client.clientName      = response.Client.clientName;
        this.client.addressOne      = response.Client.addressOne;
        this.client.addressTwo      = response.Client.addressTwo;
        this.client.addressCity     = response.Client.addressCity;
        this.client.addressPostCode = response.Client.addressPostCode;

        this.tabService.firstLoginSaveTabs(this.client.clientUid);
              
        this.clientOrOrganisationChanged(response, false);

        this.localStorageService.saveClient(this.client);
      }
      
      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  changeCurrentOrganisation(organisationUid): any 
  {
    if (organisationUid)
    {
      for (var i = 0; i < this.client.organisations.length; i++)
      {
        if (this.client.organisations[i].uid == organisationUid)
        {
          var payload = {
            clientUid: this.client.clientUid,
            organisationUid: organisationUid
          }
      
          return this.apiService.changeOrganisation(payload).pipe(map((response: any) => {
      
            if (response.Success)
            {
              this.clientOrOrganisationChanged(response, true);
      
              this.localStorageService.saveClient(this.client);

              this.selectedOrganisation = this.client.organisations[i];
              this.localStorageService.saveSelectedOrganisation(this.client.organisations[i]);
            }
            
            return response;
      
          }),
            catchError((err) => { return throwError(() => err);  })
          );
        }
      }
    }
    else
    {
      var payload = {
        clientUid: this.client.clientUid,
        organisationUid: null
      }

      return this.apiService.changeOrganisation(payload).pipe(map((response: any) => {
      
        if (response.Success)
        {
          this.clientOrOrganisationChanged(response, true);
  
          this.localStorageService.saveClient(this.client);

          this.selectedOrganisation = null;
          this.localStorageService.saveSelectedOrganisation(null);
        }
        
        return response;
  
      }),
        catchError((err) => { return throwError(() => err);  })
      );
    }
  }


  private clientOrOrganisationChanged(response, orgChanged)
  {
    this.client.assetGroups                     = Array<FilterModel>();
    this.client.jobTypes                        = Array<FilterModel>();
    this.client.userFilter                      = Array<FilterModel>();
    this.client.jobStatuses                     = Array<FilterModel>();
    this.client.organisations                   = Array<FilterModel>();
    this.client.allStockItems                   = Array<StockItemModel>();
    this.client.stlRemedialCodes                = Array<RemedialModel>();
    this.client.organisationDefaultAssetTypes   = Array<AssetTypeModel>();

    if (response.Config.alertCount)
    {
      this.client.alertCount = Number(response.Config.alertCount);
    }
    else
    {
      this.client.alertCount = 0;
    }

    if (response.Config.allDefaultAssignableAssetTypes)
    {
      for (var i = 0; i < response.Config.allDefaultAssignableAssetTypes.length; i++)
      {
        var entry = response.Config.allDefaultAssignableAssetTypes[i];
  
        var assetType = new AssetTypeModel();
  
        assetType.assetTypeUid            = Number(entry.assetTypeUid);
        assetType.assetTypeName           = entry.assetTypeName;
        assetType.assetTypeIcon           = entry.assetTypeIcon;
        assetType.organisationUid         = Number(entry.organisationUid);
        assetType.requireConditionReport  = Boolean(JSON.parse(entry.requireConditionReport));
        assetType.isStreetLight           = Boolean(JSON.parse(entry.isStreetLight));
  
        this.client.organisationDefaultAssetTypes.push(assetType);
      }
    }
    
    if (response.Config.allStlRemedials)
    {
      for (var i = 0; i < response.Config.allStlRemedials.length; i++)
      {
        var choice = response.Config.allStlRemedials[i];

        var newRem          = new RemedialModel();
        newRem.remedialUid  = Number(choice.uid);
        newRem.stlCode      = choice.stlCode;
        newRem.name         = choice.name;

        this.client.stlRemedialCodes.push(newRem);
      }
    }

    if (response.Config.allJobTypes)
    {
      for (var i = 0; i < response.Config.allJobTypes.length; i++)
      {
        var choice = response.Config.allJobTypes[i];
  
        var newChoice   = new FilterModel();
        newChoice.uid   = Number(choice.uid);
        newChoice.name  = choice.name;
  
        this.client.jobTypes.push(newChoice);
      }
    }
    
    if (response.Config.allStockItems)
    {
      for (var i = 0; i < response.Config.allStockItems.length; i++)
      {
        var stockType = response.Config.allStockItems[i];

        var newStockType   = new StockItemModel();
        newStockType.uid   = Number(stockType.uid);
        newStockType.name  = stockType.name;

        this.client.allStockItems.push(newStockType);
      }
    }

    if (response.Config.allAssetGroups)
    {
      for (var i = 0; i < response.Config.allAssetGroups.length; i++)
      {
        var choice = response.Config.allAssetGroups[i];

        var newChoice   = new FilterModel();
        newChoice.uid   = Number(choice.uid);
        newChoice.name  = choice.name;
        newChoice.organisationUid = choice.organisationUid

        this.client.assetGroups.push(newChoice);
      }
    }

    if (response.Config.allUsers)
    {
      for (var i = 0; i < response.Config.allUsers.length; i++)
      {
        var choice = response.Config.allUsers[i];

        var newChoice   = new FilterModel();
        newChoice.uid   = Number(choice.uid);
        newChoice.name  = choice.name;

        this.client.userFilter.push(newChoice);
      }
    }

    if (response.Config.allJobStatuses)
    {
      for (var i = 0; i < response.Config.allJobStatuses.length; i++)
      {
        var choice = response.Config.allJobStatuses[i];

        var newChoice   = new FilterModel();
        newChoice.uid   = Number(choice.uid);
        newChoice.name  = choice.name;

        this.client.jobStatuses.push(newChoice);
      }
    }

    if (response.Config.allOrganisations)
    {
      for (var i = 0; i < response.Config.allOrganisations.length; i++)
      {
        var choice = response.Config.allOrganisations[i];
  
        var newChoice = new FilterModel();
  
        newChoice.uid               = Number(choice.uid);
        newChoice.name              = choice.name;
        newChoice.singleLineAddress = null;
        newChoice.code              = choice.code;
  
        if (choice.singleLineAddress)
        {
          newChoice.singleLineAddress = choice.singleLineAddress;
        }
        
        if (i == 0 && !orgChanged)
        {
          // Default to first organisation on Client Change.

          this.selectedOrganisation = newChoice;
          this.localStorageService.saveSelectedOrganisation(newChoice);
        }
  
        this.client.organisations.push(newChoice);
      }
    }
  }


  public createNewAssetGroup(assetGroupName): any 
  { 
    var payload = {
      ClientUid: this.client.clientUid,
      Name: assetGroupName,
      OrganisationUid: this.getOrganisationUid()
    }

    return this.apiService.createNewAssetGroup(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client.assetGroups = Array<FilterModel>();
       
        for (var i = 0; i < response.AssetGroups.length; i++)
        {
          var aType = response.AssetGroups[i];
          var assetGroup = new FilterModel();
          assetGroup.uid   = Number(aType.uid);
          assetGroup.name  = aType.name;
          assetGroup.organisationUid = aType.organisationUid
          this.client.assetGroups.push(assetGroup);
        }

        this.localStorageService.saveClient(this.client);
      }

      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public getListOfUsers(): any 
  { 
    var payload = {
      clientUid: this.client.clientUid,
      organisationUid: this.getOrganisationUid()
    }

    return this.apiService.getListOfUsers(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        
      }

      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public getListOfAssetTypes(): any 
  { 
    var payload = {
      clientUid: this.client.clientUid,
      organisationUid: this.getOrganisationUid()
    }

    return this.apiService.getListOfAssetTypes(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        
      }

      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public getAlerts(): any 
  { 
    var payload = {
      clientUid: this.client.clientUid,
      organisationUid: this.getOrganisationUid()
    }

    return this.apiService.getAlerts(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        
      }

      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public createNewStockOrder(data): any 
  { 
    return this.apiService.createNewStockOrder(data).pipe(map((response: any) => {

      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public deleteStockOrder(data): any 
  { 
    return this.apiService.deleteStockOrder(data).pipe(map((response: any) => {

      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public createNewStockItem(data): any 
  { 
    return this.apiService.createNewStockItem(data).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client.allStockItems = Array<StockItemModel>();

        for (var i = 0; i < response.AllStockItems.length; i++)
        {
          var choice = response.AllStockItems[i];

          var newChoice   = new StockItemModel();
          newChoice.uid   = Number(choice.uid);
          newChoice.name  = choice.name;

          this.client.allStockItems.push(newChoice);
        }

        this.localStorageService.saveClient(this.client);
      }

      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public createNewJobStatus(jobStatusName): any 
  { 
    var payload = {
      ClientUid: this.client.clientUid,
      Name: jobStatusName,
      OrganisationUid: this.getOrganisationUid()
    }

    return this.apiService.createNewJobStatus(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client.jobStatuses = Array<FilterModel>();
       
        for (var i = 0; i < response.JobStatuses.length; i++)
        {
          var aType = response.JobStatuses[i];
          var jStatus = new FilterModel();
          jStatus.uid   = Number(aType.uid);
          jStatus.name  = aType.name;
          this.client.jobStatuses.push(jStatus);
        }

        this.localStorageService.saveClient(this.client);
      }

      return response;

    }),
      catchError((err) => { return throwError(() => err); })
    );
  }


  public deleteJobStatus(statusUid, clientUid): any 
  { 
    var payload = {
      statusUid: statusUid,
      clientUid: clientUid,
      organisationUid: this.getOrganisationUid()
    }

    return this.apiService.deleteJobStatus(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client.jobStatuses = Array<FilterModel>();
       
        for (var i = 0; i < response.JobStatuses.length; i++)
        {
          var aType = response.JobStatuses[i];
          var jStatus = new FilterModel();
          jStatus.uid   = Number(aType.uid);
          jStatus.name  = aType.name;
          this.client.jobStatuses.push(jStatus);
        }

        this.localStorageService.saveClient(this.client);
      }
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteAssetGroup(assetGroupUid, clientUid): any 
  { 
    var payload = {
      assetGroupUid: assetGroupUid,
      clientUid: clientUid,
      organisationUid: this.getOrganisationUid()
    }

    return this.apiService.deleteAssetGroup(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client.assetGroups = Array<FilterModel>();

        for (var i = 0; i < response.AssetGroups.length; i++)
        {
          var choice = response.AssetGroups[i];
          var newChoice = new FilterModel();
          newChoice.uid   = Number(choice.uid);
          newChoice.name  = choice.name;
          newChoice.organisationUid = choice.organisationUid
          this.client.assetGroups.push(newChoice);
        }

        this.localStorageService.saveClient(this.client);
      }
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteUser(userUid): any 
  { 
    var payload = {
      userUid: userUid,
      clientUid: this.client.clientUid,
      organisationUid: this.getOrganisationUid()
    }

    return this.apiService.deleteUser(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client.userFilter = Array<FilterModel>();

        for (var i = 0; i < response.UserFilter.length; i++)
        {
          var choice = response.UserFilter[i];
          var newChoice = new FilterModel();
          newChoice.uid   = Number(choice.uid);
          newChoice.name  = choice.name;
          this.client.userFilter.push(newChoice);
        }

        this.localStorageService.saveClient(this.client);
      }
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public createNewLocation(location): any 
  { 
    var payload = {
      clientUid: this.client.clientUid,
      locationName: location.addressName,
      addressOne: location.addressOne,
      addressTwo: location.addressTwo,
      addressCity: location.addressCity,
      addressPostCode: location.addressPostCode,
      organisationUid: location.organisationUid
    }
    
    return this.apiService.createNewLocation(payload).pipe(map((response: any) => {

      if (response.Success)
      {

      }
      
      return response;

    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public createNewUser(payload): any 
  { 
    payload.clientUid = this.client.clientUid;
    payload.organisationUid = this.getOrganisationUid();
    
    return this.apiService.createUser(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client.userFilter = Array<FilterModel>();

        for (var i = 0; i < response.UserFilter.length; i++)
        {
          var choice = response.UserFilter[i];
          var newChoice = new FilterModel();
          newChoice.uid   = Number(choice.uid);
          newChoice.name  = choice.name;
          this.client.userFilter.push(newChoice);
        }

        this.localStorageService.saveClient(this.client);
      }
      
      return response;

    }),
      catchError((err) => { return throwError(() => err); })
    );
  }

  public getOrganisationDetails(payload): any 
  { 
    return this.apiService.getOrganisationDetails(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err); })
    );
  }

  public addDefaultAssetTypeToOrganisation(payload): any 
  { 
    return this.apiService.addDefaultAssetTypeToOrganisation(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);})
    );
  }
  
  public removeDefaultAssetTypeFromOrganisation(payload): any 
  { 
    return this.apiService.removeDefaultAssetTypeFromOrganisation(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err); })
    );
  }

  public createNewOrganisation(address): any 
  { 
    var payload = {
      ClientUid: this.client.clientUid,
      Name: address.addressName,
      LineOne: address.addressOne,
      LineTwo: address.addressTwo,
      City: address.addressCity,
      PostCode: address.addressPostCode
    }
    return this.apiService.createOrganisation(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client.organisations = Array<FilterModel>();

        for (var i = 0; i < response.Organisations.length; i++)
        {
          var choice = response.Organisations[i];
          var newChoice = new FilterModel();
          newChoice.uid   = Number(choice.uid);
          newChoice.name  = choice.name;
          newChoice.code = choice.code;
          newChoice.singleLineAddress = null;

          if (choice.singleLineAddress)
          {
            newChoice.singleLineAddress = choice.singleLineAddress;
          }

          this.client.organisations.push(newChoice);
        }

        this.localStorageService.saveClient(this.client);
      }
      
      return response;

    }),
      catchError((err) => { return throwError(() => err); })
    );
  }


  public deleteOrganisation(uid): any 
  { 
    var payload = {
      clientUid: this.client.clientUid,
      organisationUid: uid
    }
    return this.apiService.deleteOrganisation(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client.organisations = Array<FilterModel>();

        for (var i = 0; i < response.Organisations.length; i++)
        {
          var choice = response.Organisations[i];
          var newChoice = new FilterModel();
          newChoice.uid   = Number(choice.uid);
          newChoice.name  = choice.name;
          newChoice.code = choice.code;
          newChoice.singleLineAddress = null;

          if (choice.singleLineAddress)
          {
            newChoice.singleLineAddress = choice.singleLineAddress;
          }

          this.client.organisations.push(newChoice);
        }

        this.localStorageService.saveClient(this.client);
      }
      
      return response;

    }),
      catchError((err) => { return throwError(() => err); })
    );
  }


  public deleteStockItem(payload): any 
  { 
    return this.apiService.deleteStockItem(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.client.allStockItems = Array<StockItemModel>();
        
        for (var i = 0; i < response.allStockItems.length; i++)
        {
          var stockType = response.allStockItems[i];

          var newStockType   = new StockItemModel();
          newStockType.uid   = Number(stockType.uid);
          newStockType.name  = stockType.name;

          this.client.allStockItems.push(newStockType);
        }
        
        this.localStorageService.saveClient(this.client);
      }
      
      return response;

    }),
      catchError((err) => { return throwError(() => err); })
    );
  }

  public getClientBadgeCount(): any 
  { 
    var payload = {
      clientUid: this.client.clientUid,
      organisationUid: this.getOrganisationUid()
    }

    return this.apiService.getClientBadgeCount(payload).pipe(map((response: any) => {

      if (response.Success)
      {
        this.badges = new BadgeModel();
        
        this.badges.alertCount = response.AlertCount;
        this.badges.stockCount = response.StockCount;
      }
      
      return response;

    }),
      catchError((err) => { return throwError(() => err); })
    );
  }


  doesClientExist(): boolean
  {
    if (this.client)
    {
      return true;
    }

    return false;
  }


  getClientName(): string
  {
    if (this.client)
    {
      return this.client.clientName;
    }

    return null;
  }


  getClientJobTypeFilters(): Array<FilterModel>
  {
    if (this.client)
    {
      return this.client.jobTypes;
    }

    return [];
  }


  getClientJobStatusFilters(): Array<FilterModel>
  {
    if (this.client)
    {
      return this.client.jobStatuses;
    }

    return [];
  }


  getClientUserFilters(): Array<FilterModel>
  {
    if (this.client)
    {
      return this.client.userFilter;
    }

    return [];
  }


  getClientAssetGroupFilters(): Array<FilterModel>
  {
    if (this.client)
    {
      return this.client.assetGroups;
    }

    return [];
  }


  getAllStockItems(): Array<StockItemModel>
  {
    if (this.client)
    {
      return this.client.allStockItems;
    }

    return [];
  }


  getClientOrganisations(): Array<FilterModel>
  {
    if (this.client)
    {
      return this.client.organisations;
    }

    return [];
  }


  getSelectedOrganisation(): FilterModel
  {
    return this.selectedOrganisation;
  }

  
  getOrganisationUid(): number
  {
    if (this.selectedOrganisation)
    {
      return this.selectedOrganisation.uid;
    }

    return null;
  }


  getOrganisationName(): string
  {
    if (this.selectedOrganisation)
    {
      return this.selectedOrganisation.name;
    }

    return null;
  }


  getAllClientsFilter(): Array<FilterModel>
  {
    return this.allClients;
  }


  getRemedialCodes(): Array<RemedialModel>
  {
    if (this.client)
    {
      return this.client.stlRemedialCodes;
    }

    return [];
  }

  getClientUid(): number
  {
    if (this.client)
    {
      return this.client.clientUid;
    }

    return null;
  }


  getClient(): ClientModel
  {
    if (this.client)
    {
      return this.client;
    }

    return null;
  }


  getJobTypes(): any
  {
    return [
      { uid: 1, name: "PPM" },
      { uid: 2, name: "Reactive" }
    ];
  }

  public getStockBadgeCount(): number 
  {
    if (this.badges)
    {
      return this.badges.stockCount;
    }

    return 0;
  }

  public getAlertBadgeCount(): number 
  {
    if (this.badges)
    {
      return this.badges.alertCount;
    }

    return 0;
  }

  
  public getDefaultAssignableAssetTypesForOrganisation(organisationUid): Array<AssetTypeModel>
  {
    var defaults = new Array<AssetTypeModel>();

    if (this.client)
    {
      for (var i = 0; i < this.client.organisationDefaultAssetTypes.length; i++)
      {
        if (this.client.organisationDefaultAssetTypes[i].organisationUid == organisationUid)
        {
          var found = JSON.parse(JSON.stringify(this.client.organisationDefaultAssetTypes[i]));
          defaults.push(found);
        }
      }
    }

    return defaults;
  }


  public getAssetGroupsForOrganisation(organisationUid): Array<FilterModel>
  {
    var assetGroups = new Array<FilterModel>();

    if (this.client)
    {
      for (var i = 0; i < this.client.assetGroups.length; i++)
      {
        if (this.client.assetGroups[i].organisationUid == organisationUid)
        {
          var found = JSON.parse(JSON.stringify(this.client.assetGroups[i]));
          assetGroups.push(found);
        }
      }
    }

    return assetGroups;
  }


  public saveDefaultAssignableAssetTypes(array) 
  {
    this.client.organisationDefaultAssetTypes = new Array<AssetTypeModel>();
              
    for (var i = 0; i < array.length; i++)
    {
      var entry = array[i];

      var assetType = new AssetTypeModel();

      assetType.assetTypeUid            = Number(entry.assetTypeUid);
      assetType.assetTypeName           = entry.assetTypeName;
      assetType.assetTypeIcon           = entry.assetTypeIcon;
      assetType.organisationUid         = Number(entry.organisationUid);
      assetType.requireConditionReport = Boolean(JSON.parse(entry.requireConditionReport));
      assetType.isStreetLight           = Boolean(JSON.parse(entry.isStreetLight));

      this.client.organisationDefaultAssetTypes.push(assetType);
    }

    this.localStorageService.saveClient(this.client);
  }
}
